module.exports = __webpack_public_path__ + "static/assets/d467b02f9062d098fbee445dc0a58d0a.png";